import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './BackToStreamButton.scss';
const BackToStreamButton = ({ className , exitDuperbrowse , parent , currentItem  })=>{
    const { t  } = useTranslation();
    // Ads
    const { adsEnabled  } = useContext(SessionContext);
    const isPrimis = useFlag('ads_primis_top');
    if (!parent || !currentItem) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TextButton, {
        icon: ArrowLeft,
        variant: "main",
        size: "small",
        biData: _object_spread_props(_object_spread({
            evid: BiEventType.BACK_TO_CLICK
        }, getBasicBiDataForDuperItem(currentItem)), {
            link_url: parent.url,
            next_itemid: parent.itemId,
            next_typeid: parent.typeId
        }),
        className: classnames(s['duperexit'], adsEnabled && !isPrimis && s['with-ad'], className),
        onClick: exitDuperbrowse,
        noHorizontalPaddings: false
    }, parent.title || t('deviation.duperbrowse.back'));
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
